import React, { Component } from 'react';
import { observer } from 'mobx-react';
import { FormattedMessage } from 'react-intl';

import FeedbackDishGroupsReportStore from 'stores/Report/Feedback/FeedbackDishGroupsReportStore';
import FeedbackDishGroupsReportForm from 'stores/Forms/Reports/Feedback/FeedbackDishGroupsReportForm';
import { getFormattedDate } from 'helpers/datetime';

import Spinner from 'components/Spinner/Spinner';
import PrintHeader from 'components/Print/Header/PrintHeader';

import style from './FeedbackDishGroupsReportTab.module.scss';
import FeedbackDishGroupsForm from './FeedbackDishGroupsForm';
import ReportTable from './ReportTable';

@observer
class FeedbackDishGroupsReportTab extends Component {
  store = new FeedbackDishGroupsReportStore();
  form = new FeedbackDishGroupsReportForm();

  componentDidMount() {
    this.store.getReport(this.form.requestParams);
    this.form.init();
  }

  render() {
    const { report } = this.store;

    return (
      <section className={style.main}>
        {this.store.loading && <Spinner contain />}

        <PrintHeader
          title={<FormattedMessage id="title.report.feedback.tab2" />}
          description={this.printDescription}
        />

        <FeedbackDishGroupsForm form={this.form} store={this.store} />

        {report.map(item => (
          <ReportTable
            key={item.dishGroupId}
            report={item}
            store={this.store}
            form={this.form}
          />
        ))}

        {!report.length && (
          <div className={style.noContent}>
            <FormattedMessage id="table.noDataText" />
          </div>
        )}
      </section>
    );
  }

  get printDescription() {
    const { period } = this.form;
    const from = getFormattedDate(period[0].toISODate());
    const to = getFormattedDate(period[1].toISODate());

    if (from === to) return from;

    return `${from} - ${to}`;
  }
}

export default FeedbackDishGroupsReportTab;
